/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const KeyEqualLabelKeyLabelValue: core.serialization.ObjectSchema<
    serializers.KeyEqualLabelKeyLabelValue.Raw,
    Truvity.KeyEqualLabelKeyLabelValue
> = core.serialization.object({
    key: core.serialization.string(),
    value: core.serialization.string(),
});

export declare namespace KeyEqualLabelKeyLabelValue {
    export interface Raw {
        key: string;
        value: string;
    }
}
